<h1 class="border-gray border-bottom text-center pb-4 mb-5">Website Pages</h1>
<div class="text-end mb-4">
	<button (click)="createPage()"
		class="btn btn-round btn-slim btn-primary">
		Add page
	</button>
</div>
<div class="card border-0 bg-white shadow-sm mb-4">
	<div class="card-body p-xl-5">
		<div class="row mb-4">
			<div class="col-12 col-lg-6 col-xl">
				<input [(ngModel)]="params.searchTerm"
					(keyup)="getPages()"
					class="form-control bordered"
					type="text"
					placeholder="Search...">
			</div>
			<div class="col-12 col-lg-6 col-xl-2">
				<ng-select [(ngModel)]="params.sort"
					[clearable]="false"
					[searchable]="false"
					(ngModelChange)="getPages()"
					placeholder="Sort By"
					class="dark">
					<ng-option *ngFor="let sort of params.sorts"
						[value]="sort.ID">
						{{sort.name}}
					</ng-option>
				</ng-select>
			</div>
		</div>
		<div *ngIf="pages.length"
			class="row">
			<div class="col-12">
				<div class="table-responsive">
					<table *ngIf="pages.length && (user$ | async)"
						class="table table-borderless ys-table">
						<thead>
							<tr>
								<th>Page name</th>
								<th>Created</th>
								<th>Sections</th>
								<th>In Footer?</th>
								<th>Quick Link</th>
								<th>External Link</th>
								<th>Status</th>
								<th>Action</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let page of pages; let i = index"
								[ngClass]="{'tr-odd': isOdd(i)}"
								class="toplined">
								<td (click)="updatePage(page)">
									<span>{{page.name}}</span>
								</td>
								<td (click)="updatePage(page)">
									{{page.created | date:'dd MMM yyyy'}}
								</td>
								<td>
									<small [ngClass]="{'label-danger' : page.totalSnippets === 0, 'label-success' : page.totalSnippets > 0}"
										class="label">
										{{page.totalSnippets}}
									</small>
								</td>
								<td>
									<a (click)="setQL(page, 'qlFooter')">
										<small *ngIf="!page.qlFooter"
											class="label label-danger">
											No
										</small>
										<small *ngIf="page.qlFooter"
											class="label label-success">
											Yes
										</small>
									</a>
								</td>
								<td>
									<a (click)="setQL(page, 'qlPlugin')">
										<small *ngIf="!page.qlPlugin"
											class="label label-danger">
											No
										</small>
										<small *ngIf="page.qlPlugin"
											class="label label-success">
											Yes
										</small>
									</a>
								</td>
								<td>
									<a (click)="setExternal(page)">
										<small *ngIf="!page.external"
											class="label label-danger">
											No
										</small>
										<small *ngIf="page.external"
											class="label label-success">
											Yes
										</small>
									</a>
								</td>
								<td>
									<a (click)="setStatus(page)">
										<small *ngIf="!page.active"
											class="label label-danger">
											Inactive
										</small>
										<small *ngIf="page.active"
											class="label label-success">
											Active
										</small>
									</a>
								</td>
								<td>
									<a (click)="updatePage(page)">
										<img src="assets/images/icon-edit.svg" class="custom-edit-icon">
									</a>
									<a (click)="deleteConfirm(page)"
										class="ms-2">
										<img src="assets/images/icon-trash.svg" class="custom-delete-icon">
									</a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</div>
<app-confirmation *ngIf="this.confirmationData.open"
	[data]="confirmationData"
	(complete)="confirmAction($event)"></app-confirmation>
